import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [ 'bigCardContainer' ]

  connect() {
    setTimeout(this._scrollCard, 100)
  }

  show(e) {
    this._selectCard(e)
    this._showSpinner()
  }

  // Private methods

  _selectCard(e) {
    const smallCard = e.target.closest(".small_cards__item")
    if (!smallCard) return

    unselectCards()
    smallCard.classList.add("selected-card")
  }

  _showSpinner() {
      const bigCardContainer = this.bigCardContainerTarget
      const spinnerHTML =
    ` <div class="loading-spinner-container">
        <div id="loading-spinner"></div>
      </div>
    `
      bigCardContainer.innerHTML = spinnerHTML
  }

  // Only the list scrolls to the selected card: scrolling the page would carry the toolbar and the search away.
  _scrollCard() {
    const selectedCard = document.querySelector(".selected-card")
    if(!selectedCard) return

    const container = selectedCard.closest(".small_cards__container")
    if (container && /(auto|scroll)/.test(getComputedStyle(container).overflowY)) {
      const top = selectedCard.getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop
      container.scrollTo({ top, behavior: "smooth" })
    } else {
      selectedCard.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" })
    }
  }
}
